import React from "react";
import Footer from "../../components/Footer";
import Navbar from "../../components/Navbar";
import EMICalculator from "../../components/EMICalculator";
import LoanProduct from "../../components/LoanProducts";
import ContactIcon from "../../assets/Images/component/contactIcon.svg";
import EligibilityCriteria from "../../assets/Images/Home/EligibilityCriteria.png";
import DocumnetReq from "../../assets/Images/Home/Documnet-req.png";
import creditScore from "../../assets/Images/Home/creditScore.png";
import instaLoanCreditTool from "../../assets/Images/Home/instaLoanCreditTool.jpg";
import TextImageSection from "../Home/component/TextImageSection";
import CreditScoreMeter from "../../components/CreditScoreNew";

export const CreaditTools = () => {
  const Products = [
    {
      title: "Eligibility Criteria",
      icon: ContactIcon,
      image: EligibilityCriteria,
      list: ["Age 21- 65", "Employment status"],
      color: {
        iconBg: "#DECEE5",
        contentBg: "#DECEE5",
        borderColor: "#6F4C9F",
      },
    },
    {
      title: "Documents Required",
      icon: ContactIcon,
      image: DocumnetReq,
      list: ["Pan card", "Aadhar card", "Address proof"],
      color: {
        iconBg: "#F0EFA2",
        contentBg: "#F0EFA254",
        borderColor: "#AB882E",
      },
    },
    {
      title: "Credit Score",
      icon: ContactIcon,
      image: creditScore,
      list: ["Age 21- 65", "Employment status"],
      color: {
        iconBg: "#9BD7D0",
        contentBg: "#9BD7D033",
        borderColor: "#9BD7D0",
      },
    },
  ];
  return (
    <>
      <Navbar />
      <div className="credit-tool-section">
        <div className={`active section-content-value`}>
          <CreditScoreMeter />
        </div>
        <div className={`active section-content-value`}>
          <EMICalculator />
        </div>
        <div className="loan-product-credit-tool">
          <div className="need-know-section flex">
            {Products?.map((item) => (
              <LoanProduct
                icon={item?.icon}
                title={item?.title}
                thumbnail={item?.image}
                list={item?.list}
                color={item?.color}
              />
            ))}
          </div>
        </div>

        <TextImageSection
          view={"heading-then-image"}
          image={instaLoanCreditTool}
          heading={"Instant loan to move up in life"}
          button="Apply Now"
          custumeClass="center-section leading-partner image-hr-text insta-loan credit-tool-instaloan"
        ></TextImageSection>
      </div>

      <Footer custumeClass="landing-page-footer !bg-inherit !border-0" />
    </>
  );
};
